import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from "react-router-hash-link";

const Cta = () => {
    return (
        <div className="w-full flex items-center justify-center text-white cta">
            <div className="mx-8 w-full h-auto text-center lg:text-left py-20 px-4 sm:px-12 flex flex-col lg:flex-row justify-center items-center">
                <div className="w-full flex flex-col lg:flex-row lg:justify-between items-center gap-10">
                    <div className="w-full lg:w-1/2">
                        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 leading-snug">
                            Ready to make a difference?
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl text-gray-200 leading-relaxed">
                            Whether you're donating shoes or joining our next event,{' '}
                            <span className="font-semibold text-white">we'd love to have you involved.</span>
                        </p>
                    </div>

                    <div className="w-full lg:w-64 flex flex-col gap-3 items-center lg:items-start">
                        <Link
                            to="/contact"
                            className="w-full bg-white text-black text-center rounded-xl px-8 py-3 font-semibold hover:bg-gray-100 transition-all duration-200 flex items-center justify-center group"
                        >
                            Contact Us
                            <svg className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform duration-300"
                                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd"
                                      d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                                      clipRule="evenodd" />
                            </svg>
                        </Link>

                        <HashLink
                            smooth to="/#getinvolved"
                            className="w-full bg-transparent border border-white/60 text-white text-center rounded-xl px-8 py-3 font-medium hover:bg-white/10 transition-all duration-200 flex items-center justify-center group"
                        >
                            Find the Next Event
                            <svg className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform duration-300"
                                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd"
                                      d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                                      clipRule="evenodd" />
                            </svg>
                        </HashLink>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cta;
